import { customElement } from "lit/decorators.js";
import { html } from "lit";
import { ref } from "lit/directives/ref.js";
import { Task } from "@lit/task";
import { MenuBaseElement, MenuBaseElementProps } from "./MenuBaseElement";
import { domainsPromise } from "./domains";
import { appsPromise } from "./apps";

export type M2MAppsMenuProps = MenuBaseElementProps;

@customElement("m2m-apps-menu")
export class M2MAppsMenu extends MenuBaseElement {
  private _dataTask = new Task(this, {
    task: async (_: unknown, { signal }) => {
      const apps = await appsPromise(signal);

      const domains = await domainsPromise(signal);
      return { apps, domains };
    },
    args: () => [],
  });

  render() {
    const isHidden = this.expanded === false || this.expanded === undefined;

    const additionalItems = this.additinalItems?.map((item) => {
      return html`
        <li>
          <a href="${item.href}">${item.label}</a>
        </li>
      `;
    });

    return html`<nav>
      <button
        type="button"
        class="navigation-drawer-controll-button navigation-drawer-controll-button--icon"
        aria-controls="m2m-apps-menu__navigation-drawer"
        aria-expanded=${this.expanded}
        @click=${this.handleToggleDrawer}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38px"
          height="38px"
          viewBox="0 0 24 24"
        >
          <path
            d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
          />
        </svg>
      </button>
      <ul
        ${ref(this.listRef)}
        id="m2m-apps-menu__navigation-drawer"
        aria-hidden=${isHidden}
        class="navigation-drawer"
      >
        ${this._dataTask.render({
          pending: () => html`<li><a disabled href="#">Loading...</a></li>`,
          complete: ({ apps, domains }) => {
            return apps.map((app) => {
              return app.type === "group"
                ? html`
                    <li>
                      <span>${app.label}</span>
                      <ul>
                        ${app.children.map((child) => {
                          // 2段ネストはサポートしない
                          if (child.type === "link") {
                            return html`
                              <li>
                                <a href="${domains[child.key]}"
                                  >${child.label}</a
                                >
                              </li>
                            `;
                          }
                        })}
                      </ul>
                    </li>
                  `
                : html`
                    <li>
                      <a href="${domains[app.key]}">${app.label}</a>
                    </li>
                  `;
            });
          },
        })}
        ${additionalItems}
      </ul>
    </nav>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "m2m-apps-menu": M2MAppsMenu;
  }
}
